export class TipoPublicacion {
  public id: number;
  public nombre: string;

  constructor() { }
}
